// @flow

import React from 'react';

import Keydown, { type Props } from './Keydown';

const WindowKeydown = (props: Props) => (
  <Keydown isGlobalEvent={true} {...props} />
);

export default WindowKeydown;
